import clsx from 'clsx/lite';
import { type FC } from 'react';
import styles from './TableHeaderRow.module.css';
import type { HeaderItem } from './types';

interface TableHeaderRowProps {
  isHeader?: boolean;
  headers?: Array<HeaderItem>;
}

const TableHeaderRow: FC<TableHeaderRowProps> = ({ headers }) => {
  if (!headers?.length) {
    return null;
  }

  return (
    <tr>
      {headers?.map(({ key, className, width, children, ...rest }) => (
        <th key={key} className={clsx(styles.cell, className)} style={{ width }} {...rest}>
          {children ?? null}
        </th>
      ))}
    </tr>
  );
};

export default TableHeaderRow;
